import { useQuery } from "@tanstack/react-query";

import { getAdminFarmPayoutApprovals, getFarmPayoutApprovals } from "services";

import { getFarmIdFromLocalStorage } from "utils";

import { FARM_PAYOUT_APPROVALS, FARM_PAYOUT_APPROVALS_ADMIN } from "consts";

export const useGetFarmPayoutApprovals = () => {
  const farmId = getFarmIdFromLocalStorage();

  return useQuery({
    queryKey: [FARM_PAYOUT_APPROVALS, farmId],
    queryFn: () => getFarmPayoutApprovals(),
    enabled: !!farmId,
  });
};

export const useGetFarmPayoutApprovalsAdmin = ({ farmId }: { farmId: string }) =>
  useQuery({
    queryKey: [FARM_PAYOUT_APPROVALS_ADMIN, farmId],
    queryFn: () => getAdminFarmPayoutApprovals({ farmId }),
    enabled: !!farmId,
  });
